// extracted by mini-css-extract-plugin
export default {"selected":"CategoryList_selected__euBA6"};